import React, { useState } from 'react';
import { RevenueReportView } from './RevenueReportView';
import { FamilyBookingTrendView } from './FamilyBookingTrendView';
export const AgentView = () => {
  const [userInput, setUserInput] = useState('');
  const [showReport, setShowReport] = useState(false);
  const [showFamilyTrend, setShowFamilyTrend] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const handleInputChange = e => {
    setUserInput(e.target.value);
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (!userInput.trim()) return;
    // Add user message to chat history
    const newChatHistory = [...chatHistory, {
      sender: 'user',
      text: userInput
    }];
    setChatHistory(newChatHistory);
    // Check for specific OOTB query for standard room
    if (userInput.toLowerCase().includes('ootb numbers for a standard room')) {
      // Add agent response with the specific OOTB message
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: 'Sure. There are 75 OOTB reservations today for 85% occupancy'
      }]);
    }
    // Check if the user is asking about rooms booked in the past day
    else if (userInput.toLowerCase().includes('how many rooms have booked in the past day') || userInput.toLowerCase().includes('tell me how many rooms have booked in the past day')) {
      // Add agent response for rooms booked
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: '8 rooms'
      }]);
    }
    // Check if the user is asking about family bookings
    else if (userInput.toLowerCase().includes('how many of the rooms booked are families')) {
      // Add agent response for family bookings
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: '6 families have booked'
      }]);
    }
    // Check if the user is asking about family booking trends
    else if (userInput.toLowerCase().includes('trend over the past month with families booking') || userInput.toLowerCase().includes('family booking trend')) {
      // Add agent response for family booking trend
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: "Here's the family booking trend report for the past month:"
      }]);
      // Show the family booking trend report
      setShowFamilyTrend(true);
    }
    // Check if the user is requesting the daily revenue report
    else if (userInput.toLowerCase().includes('daily revenue report')) {
      // Add agent response
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: "Here's the daily revenue report you requested:"
      }]);
      // Show the report
      setShowReport(true);
      setShowFamilyTrend(false);
    } else if (userInput.toLowerCase().includes('ootb report')) {
      // Add agent response for OOTB report
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: "I'll prepare the Out of the Box report for you. This report is currently being generated."
      }]);
    } else if (userInput.toLowerCase().includes('pacing report')) {
      // Add agent response for Pacing report
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: "I'll generate the Pacing report for you. This will show you how your bookings are tracking against previous periods."
      }]);
    } else {
      // Generic response for other inputs
      setChatHistory([...newChatHistory, {
        sender: 'agent',
        text: 'I can help you with that. Would you like to see any specific reports or analytics?'
      }]);
    }
    // Clear the input
    setUserInput('');
  };
  const handleBackToChat = () => {
    setShowReport(false);
    setShowFamilyTrend(false);
  };
  // Example queries for the user to try
  const exampleQueries = ['I need a daily revenue report', 'Can you show me the pacing report compared to last year?', 'What is the current occupancy rate?'];
  // Function to set input to an example query
  const setExampleQuery = query => {
    setUserInput(query);
  };
  return <div className="p-6 h-full" data-id="element-57">
      {!showReport && !showFamilyTrend ? <div className="bg-white rounded-lg shadow-sm p-6 h-full flex flex-col" data-id="element-58">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4" data-id="element-59">
            Agent Interaction
          </h2>
          <div className="flex-1 flex flex-col" data-id="element-60">
            <div className="flex-1 bg-gray-50 rounded-lg p-4 mb-4 overflow-auto" data-id="element-61">
              {chatHistory.length === 0 ? <div className="text-center text-gray-500 mt-12" data-id="element-62">
                  <svg className="mx-auto h-12 w-12 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-63">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" data-id="element-64" />
                  </svg>
                  <h3 className="mt-2 text-lg font-medium" data-id="element-65">
                    Start a conversation
                  </h3>
                  <p className="mt-1 text-sm mb-3" data-id="element-66">
                    Ask the agent to help you derive charts and services for
                    your hospitality needs.
                  </p>
                  <div className="flex flex-col gap-2 items-center mt-4" data-id="element-67">
                    <p className="text-xs font-medium text-gray-500" data-id="element-68">
                      Try asking:
                    </p>
                    <div className="flex flex-wrap justify-center gap-2" data-id="element-69">
                      {exampleQueries.map((query, index) => <button key={index} onClick={() => setExampleQuery(query)} className="text-sm text-teal-600 hover:text-teal-700 bg-teal-50 hover:bg-teal-100 px-3 py-1.5 rounded-full transition-colors" data-id="element-70">
                          "{query}"
                        </button>)}
                    </div>
                  </div>
                </div> : <div className="space-y-4" data-id="element-71">
                  {chatHistory.map((message, index) => <div key={index} className={`flex ${message.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-72">
                      <div className={`max-w-[80%] rounded-lg px-4 py-2 ${message.sender === 'user' ? 'bg-teal-500 text-white' : 'bg-gray-200 text-gray-800'}`} data-id="element-73">
                        {message.text}
                      </div>
                    </div>)}
                </div>}
            </div>
            <form onSubmit={handleSubmit} className="relative" data-id="element-74">
              <input type="text" value={userInput} onChange={handleInputChange} placeholder="Ask me anything about your hospitality data..." className="w-full p-3 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent" data-id="element-75" />
              <button type="submit" className="absolute right-2 top-1/2 transform -translate-y-1/2 text-teal-500 hover:text-teal-600 p-1 rounded-full" data-id="element-76">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-77">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" data-id="element-78" />
                </svg>
              </button>
            </form>
          </div>
        </div> : <div className="bg-white rounded-lg shadow-sm h-full flex flex-col" data-id="element-79">
          <div className="p-3 border-b border-gray-200" data-id="element-80">
            <button onClick={handleBackToChat} className="flex items-center text-gray-600 hover:text-gray-800" data-id="element-81">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-82">
                <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" data-id="element-83" />
              </svg>
              <span className="text-sm font-medium" data-id="element-84">Back to Agent</span>
            </button>
          </div>
          <div className="flex-1 overflow-auto" data-id="element-85">
            {showReport && <RevenueReportView mode="save" data-id="element-86" />}
            {showFamilyTrend && <FamilyBookingTrendView data-id="element-87" />}
          </div>
        </div>}
    </div>;
};